<template>
    <div style="width:100%; box-sizing: border-box;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>


      <div style="width:100%; box-sizing: border-box; text-align: left;">
        <h2 class="painted_header_h2 color3"><span style="color:inherit; font-weight:500;">Idősáv beállítás - {{Karszam}}</span></h2>
        <br><br>

        <div class="general_infotext"  style="margin:10px 0px;">
            Kérjük adja meg a várost ahol a szolgáltatást elsősorban igénybe szeretné venni! Budapest esetében kiválaszthatja az Ön által preferált kerületet is.
        </div>

        <GrcAutoComplete ref="txtVarosEllatas" v-model="txtVarosEllatas" grc_labeltext="Város:"
        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300" grc_dropdownmaxwidth="500"  
        grc_keyfield="id" grc_displayfield="Megnevezes" grc_dropdownheight="150"
        grc_readonly="false"
        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
        v-on:dropdownopened="SetPopupRef('txtVarosEllatas')"
        v-on:dropdownclosed="SetPopupRef('')"
        v-on:grc-keydown-enter="SetControlToFocus('');"
        style="margin-bottom:20px; max-width:500px; margin-top:10px;"
        />

        <div class="general_infotext" style="margin-top:20px;">Amennyiben megjegyzést kíván fűzni a helyszínhez, van preferált szolgáltatója vagy olyan, akihez menni szeretne stb. tegye meg itt!</div>
        <GrcTextArea ref="txtVarosEllatasMegjegyzes"
        grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" 
        grc_areaheight="80px"
        style="margin-top:10px;"
        />



        <div class="innerform_header" style="margin-top:20px;">Időpontok megadása</div>

        <div class="infotext" style="margin-bottom:10px;">
            <div class="general_infotext" style="margin:10px 0px; text-align:justify;">
                Adjon meg legalább 5 különböző napot és naponta egy három órás idősávot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 2. nap lehet.
            </div>

            <div class="general_infotext" style="margin:10px 0px; text-align:justify;">
                Adjon meg legalább 5 különböző napot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 2. nap lehet.
            </div>

        </div>

        <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 10px; font-weight:500;" >
            <div class="idopont_list_header"><i class="far fa-calendar-alt" style="margin-right:10px;"></i>Időpontok listája</div>
        </div>

        <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 20px;" v-show="Idopontok.length==0&&IdopontInputMode==0">
            A lista még üres
        </div>

        <div class="idopont_cont" v-show="Idopontok.length>0">
            <div class="idopont_item" v-for="(idopont, idopontindex) in Idopontok">
                <table class="idopont_item_text" cellspacing="0" cellpadding="0">
                    <tr>
                        <td>
                            <span style="margin-right:20px;">
                                {{idopont.DatumTol}} - {{idopont.DatumIg}}
                            </span>
                            <span style="white-space: nowrap;">
                                {{idopont.TimeTol}} - {{idopont.TimeIg}}
                            </span>
                        </td>
                        <td style="width:30px; text-align:center; cursor:pointer; color:red; font-size: 20px; line-height: 20px;" @click="IdopontTorles(idopontindex)">
                            <i class="fal fa-times-circle"></i>
                        </td>

                    </tr>
                </table>
            </div>
        </div>

        <div class="btncont" style="text-align: center; margin: 10px 0px;" v-show="IdopontInputMode==0">

            <span @click="btnIdopont_Uj_click" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                <span><i class="fal fa-plus" style="margin-right: 4px;"></i>Új időpont hozzáadás</span>
            </span>                                        

        </div>


                <div ref="IdopontInput" class="UjIdopont_cont" v-show="IdopontInputMode>0">

                    <div class="IdopontInput_row">
                
                        <GrcDate ref="txtDatumTol" v-model="txtDatumTol" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Kezdő dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('txtDatumIg');"
                        v-on:dropdownopened="SetPopupRef('txtDatumTol')"
                        v-on:onlydropdownclosed="txtDatumTol_OnInput"
                        
                        class="UjIdopont_mezo"
                        />

                        <GrcDate ref="txtDatumIg" v-model="txtDatumIg" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Záró dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeTol');"
                        v-on:dropdownopened="SetPopupRef('txtDatumIg')"
                        v-on:onlydropdownclosed="txtDatumIg_OnInput"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="IdopontInput_row">

                        <GrcCombo ref="cboTimeTol" v-model="TimeTol" grc_labeltext="Kezdő időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeTol')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeIg');"
                        class="UjIdopont_mezo"
                        />

                        <GrcCombo ref="cboTimeIg" v-model="TimeIg" grc_labeltext="Záró időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeIg')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="btncont" style="margin-top:30px;">

                        <span @click="btnIdopontMentes" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                            <span><i class="fal fa-check" style="margin-right: 4px;"></i>Hozzáadás a listához</span>
                        </span>                                        

                        <span @click="btnIdopontMegsem" class="painted_linkbutton2 color7" style="margin: 4px 0px;">
                            <span><i class="fal fa-times" style="margin-right: 4px;"></i>Mégsem</span>
                        </span>                                        


                    </div>

                </div>
    

                <div class="btncont" style="margin-top:50px;" v-show="IdopontInputMode==0">

                    <span @click="Mentes" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                        <span><i class="fal fa-check" style="margin-right: 4px;"></i>Mentés</span>
                    </span>                                        

                </div>



          


        </div>


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcAutoComplete from '../GrcComponents/GrcAutoComplete.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'


export default {
  name: 'frmidosavmodositas',
  components: {
      GrcDB,
      GrcDialog,
      GrcAutoComplete,
      GrcTextArea,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      GrcDate,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmIdosavModositas_",
          KarID:0,
          Karszam:"",
          txtVarosEllatas:"",

          txtDatumTol:"",
          txtDatumIg:"",
          TimeTol:0,
          TimeIg:0,

          IdopontInputMode:0,
          Idopontok:[],

          MinDate: "",
          MaxDate:"",

          UgyfelID:0,
          SzolgaltatasID:0,

          ReturnAlias:"",

          HELYSEGEK:[],



      }
  },
  model: {

  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },


    SetLang()
    {
      this.Init();
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },

    GoToReturnAlias()
    {
        if (this.ReturnAlias == "") { this.ReturnAlias = "dashboard"; }

        this.ReturnAlias = "dashboard"; // itt lehet kezelni, hogy honnan jött, de itt kell beállítani, hogy ne adhasson meg bármilyen más domain-re irányítást!

        document.location = this.ReturnAlias;
    },


    async Init()
      {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iKarID: this.KarID,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.GoToReturnAlias();
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].IdosavModosEngedely = 0) { this.GoToReturnAlias(); return; }

        this.Karszam = Q.RESULT[0].Karszam;

        this.HELYSEGEK = Q.HELYSEGEK;
        this.$refs.txtVarosEllatas.SetDataSource(this.HELYSEGEK);
        this.$refs.txtVarosEllatas.SetText("");

        this.MinDate = Q.RESULT[0].MinDate;
        this.MaxDate = Q.RESULT[0].MaxDate;

        this.UgyfelID = Q.RESULT[0].UgyfelID;
        this.SzolgaltatasID = Q.RESULT[0].SzolgaltatasID;

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);

        this.$refs.cboTimeTol.SetDataSource(Q.IDOPONTOK);
        this.$refs.cboTimeIg.SetDataSource(Q.IDOPONTOK);


      },

      GetIdosavXml()
      {
        var res = "<NewDataSet>";
        for(var i=0; i<this.Idopontok.length; i++)
        {
            res = res 
            +"<IDOSAV>"
            + "<DatumTol>"+this.Idopontok[i].DatumTol+"</DatumTol>"
            + "<DatumIg>"+this.Idopontok[i].DatumIg+"</DatumIg>"
            + "<IdoTol>"+this.Idopontok[i].TimeTol+"</IdoTol>"
            + "<IdoIg>"+this.Idopontok[i].TimeIg+"</IdoIg>"
            +"</IDOSAV>";
        }
        res = res + "</NewDataSet>";

        return res;
      },

      async CheckIdosavok()
      {
          var res = true;

          var pIdosavok = this.GetIdosavXml();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          iSzolgaltatasID: this.SzolgaltatasID,
          sIdosavok: pIdosavok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_CheckIdosavok", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();

            await this.ShowResult(Q.APPERR[0].ERR, 200);
            res = false;
        }

        this.$refs.GRCDB.HideLoading();

        return res;
      },



      async Mentes()
      {
        var VN = this.$refs.txtVarosEllatas.GetText().trim().toLowerCase();
        if (VN == "")
        {
            this.ShowResult("Kérjük adja meg a várost!", 200);
            return;
        }

        var VarosOK = false;

        for(var i=0; i<this.HELYSEGEK.length;i++)
        {
            if (VN == this.HELYSEGEK[i].Megnevezes.trim().toLowerCase())
            {
                VarosOK = true;
                break;
            }
        }

        if (VarosOK == false)
        {
            this.ShowResult("Kérjük válasszon a listában szereplő városok közül!", 200);
            return;
        }

        if (await this.CheckIdosavok() == false) { return; }

        var pIdosavok = this.GetIdosavXml();

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iKarID: this.KarID,
          sVaros: this.$refs.txtVarosEllatas.GetText().trim(),
          sIdosavok: pIdosavok,
          sVarosMegjegyzes: this.$refs.txtVarosEllatasMegjegyzes.GetText(),
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIdosavModositas_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].strResult, 250).then(res => 
        { 
            if (Q.RESULT[0].intResult == 1)
            {
                this.GoToReturnAlias();
            }
        });               

      },


    btnIdopont_Uj_click()
    {
        this.$refs.txtDatumTol.SetText("");
        this.$refs.txtDatumIg.SetText("");
        this.$refs.cboTimeTol.SetValue(0);
        this.$refs.cboTimeIg.SetValue(0);
        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.IdopontInputMode = 1;
    },

    btnIdopontMentes()
    {
        if ((this.$refs.txtDatumTol.GetText() == "")||(this.$refs.txtDatumIg.GetText() == ""))
        {
            this.ShowResult("A dátumok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.txtDatumTol.IsValid(false) == false)
        {
            this.ShowResult("A kezdő dátum helytelen!", 200);
            return;
       }

        if (this.$refs.txtDatumIg.IsValid(false) == false)
        {
            this.ShowResult("A záró dátum helytelen!", 200);
            return;
       }

        //if ((this.ELLCSOPSELECTED !="6")&&(this.ELLCSOPSELECTED !="9"))
        //{
            if ((this.$refs.cboTimeTol.GetValue() == 0)||(this.$refs.cboTimeIg.GetValue() == 0))
            {
                this.ShowResult("Az időpontok megadása kötelező!", 200);
                return;
            }

            if (this.$refs.cboTimeIg.GetValue() - this.$refs.cboTimeTol.GetValue() < 6)
            {
                this.ShowResult("Kérjük legalább 3 órás időszakot adjon meg!", 200);
                return;
            }
        //}


        var DTOL = this.$refs.txtDatumTol.GetText();
        var DIG = this.$refs.txtDatumIg.GetText();

        var TTOL = this.$refs.cboTimeTol.GetText();
        var TIG = this.$refs.cboTimeIg.GetText();

        /*
        if ((this.ELLCSOPSELECTED =="6")||(this.ELLCSOPSELECTED =="9"))
        {
            TTOL = "08:00";
            TIG = "20:00";
        }
        */

        if (DTOL.localeCompare(DIG) == 1)
        {
            this.ShowResult("A dátumok megadása helytelen!", 200);
            return;
        }

        if (TTOL.localeCompare(TIG) == 1)
        {
            this.ShowResult("Az időpontok megadása helytelen!", 200);
            return;
        }


        var idopontitem = { DatumTol: DTOL, DatumIg: DIG, TimeTol: TTOL, TimeIg: TIG, TimeTolID: this.$refs.cboTimeTol.GetValue(), TimeIgID: this.$refs.cboTimeIg.GetValue()};

        this.Idopontok.push(idopontitem);


        this.IdopontInputMode = 0;
    },

    btnIdopontMegsem()
    {
        this.IdopontInputMode = 0;
    },

    IdopontTorles(pIndex)
    {
        this.Idopontok.splice(pIndex,1);
    },

    txtDatumTol_OnInput(pNewValue)
    {
        this.SetPopupRef('');
        var MD = this.MinDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumIg.SetMinMaxDate(MD, this.MaxDate);

        //console.log("tol: "+pNewValue);
    },

    txtDatumIg_OnInput(pNewValue)
    {
        this.SetPopupRef('');

        var MD = this.MaxDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, MD);

        //console.log("ig: "+pNewValue);
    },




  },
  created()
  {

  },
  mounted()
  {
    this.KarID = 0;
    this.ReturnAlias = "";

    if (GRCAPP_GetParameters.hasOwnProperty("KARID"))
    {
        try
        {
            this.KarID = parseInt(GRCAPP_GetParameters.KARID);
        } catch
        {
            this.KarID = 0;
        }
    }

    if (this.KarID == 0)
    {
        document.location = "dashboard";
        return;
    }

    if (GRCAPP_GetParameters.hasOwnProperty("RETURNALIAS"))
    {
        this.ReturnAlias = GRCAPP_GetParameters.RETURNALIAS;
    }


    this.SetLang();

  }

}


</script>


<style scoped>

.outer_cont
{
    width:100%;
    box-sizing: border-box;
    max-width: 800px;
    padding:4px;
    margin-left:auto;
    margin-right:auto;
    display:block;
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
}

.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 8px 8px;
    background-color: var(--themecolor3);
    color: #fff;    
    margin-bottom:20px;
    border-radius: 3px;
}

.infotext
{
    width:100%;
    box-sizing: border-box;
}

.idopont_list_header
{
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
    font-weight: normal;
    text-align: left;

    background-color: var(--themecolor3);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-bottom: 10px;
    width:100%;
    max-width: 600px;
}

.idopont_cont
{
    width:100%;
    box-sizing: border-box;
}

.idopont_item
{
    width:100%;
    box-sizing: border-box;
    padding: 8px 4px;
    border:solid 1px #ccc;
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;    
    -webkit-box-shadow: #ddd 2px 2px 4px;
    box-shadow: 2px 2px 4px #ddd;   
    font-size: 16px;
    line-height: 18px     
}

.idopont_item:hover
{
    background-color: #f0f0f0;
}

.idopont_item_text
{
    width:100%;
    font-size: 16px;
    line-height: 18px    
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.UjIdopont_cont
{
    width: 100%;
    box-sizing: border-box;
    max-width: 600px;
    margin: 0px auto;
    padding: 4px;
    border: solid 1px #ccc;
    -webkit-box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    background-position: 0px 22px;
    border-radius: 3px;    
}

.IdopontInput_row
{
    width:100%;
    box-sizing: border-box;
    max-width: 600px;
    margin:0px auto;
}

.UjIdopont_mezo
{
    width:50%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 5px;    
}


@media (max-width:670px)
{

}

</style>